export const zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  rightSidebar: 1200,
  drawer: 1170,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
  loadingSpinner: 3000,
};
